module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('contact-detail', {
    attrs: {
      "row-data": _vm.profile(),
      "prefix": "User Profile"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-852b3bda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/UserProfile.vue
// module id = 1584
// module chunks = 0